import { useOutletContext } from 'react-router-dom'

import { CandidateDetailFragment } from 'generated/resources/graphql'

import { SectionContent } from './SectionContent'

interface OutletContext {
  candidate: CandidateDetailFragment //CandidateCvFragment
}

const CandidateCvPage = () => {
  const { candidate } = useOutletContext<OutletContext>()

  return <SectionContent candidateId={candidate.id} />
}

export default CandidateCvPage
